// extracted by mini-css-extract-plugin
export default {"saveButton":"app-portainer-settings-edge-compute-EdgeComputeSettings-EdgeComputeSettings-module__save-button"};